module.exports = "::ng-deep .mat-dialog-container {\n  padding: 0 !important;\n  margin: 0 !important; }\n\n.header-success {\n  background-color: #ff8900 !important;\n  margin-top: -25px !important; }\n\n.width-buttons {\n  width: 150px !important; }\n\n.position-buttons {\n  text-align: center !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/gastos/dialogs/update-gasto/update-gasto.component.scss
// module id = ./src/app/gastos/dialogs/update-gasto/update-gasto.component.scss
// module chunks = main